<template>
  <main class="main product-page page-inside">
    <div class="main-wrapper">
      <section class="section hero-section">
        <div class="wrapper"></div>
      </section>
      <section class="section preview-section">
        <div class="wrapper">
          <transition name="fade">
            <div class="product-preview" v-if="productPageItem">
              <div class="preview-container">
                <div class="preview-wrapper">
                  <div class="preview">
                    <img
                      :src="$parent.imgDomain + productPageItem.image_url"
                      class="img"
                    />
                  </div>
                </div>
              </div>
              <div class="text">
                <div class="text-wrapper">
                  <div class="left">
                    <div class="preview-tag desc" v-if="tag">
                      <b>{{ tag }}</b>
                    </div>
                    <div class="title regular">{{ productPageItem.title }}</div>
                    <div class="spec-text">
                      <div class="list">
                        <div class="item" v-if="category.length">
                          <div class="title">In categories:</div>
                          <div class="desc small gray">
                            {{ category }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="right">
                    <div class="price-container">
                      <div class="price-title title">
                        {{ productPageItem.price }}
                      </div>
                      <div class="price-value title">
                        <span class="currency">{{ currency }}</span>
                      </div>
                    </div>
                    <button
                      class="button"
                      @click="openBuyModal(productPageItem)"
                    >
                      {{
                        productPageItem.type == "pack"
                          ? "Get pack"
                          : "Get prompt"
                      }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="description-container">
                <div class="description">
                  <div class="desc small">
                    <b>Description:</b>
                  </div>
                  <div class="desc small">
                    After your purchase, you will receive a carefully crafted prompt. Simply load it into your preferred AI service to generate results like the examples shown.
                  </div>
                </div>
              </div>
            </div>
          </transition>
          <transition name="fade">
            <div
              class="list products"
              v-if="
                productPageItem &&
                productPageItem.type != 'prompt' &&
                productList
              "
            >
              <div class="item" v-for="(item, i) in productList" :key="i">
                <ProductCard
                  :models="modelOptions"
                  :tag="item.parent_cat_id"
                  :item="item"
                  :sliderIsClickble="true"
                  @goToProduct="goToProduct"
                  :currency="currency"
                />
              </div>
              <div class="title no-products" v-if="!productList.length">
                No products!
              </div>
            </div>
          </transition>
        </div>
      </section>
    </div>
  </main>
</template>
<script>
import ProductCard from "../components/ProductCard.vue";
export default {
  name: "ProductPage",
  props: ["currency", "productPageItem", "currencyValue", "modelOptions"],
  components: { ProductCard },
  data: function () {
    return {
      tag: "",
      category: [],
      models: [],
      categories: [],
      productList: [],
    };
  },
  watch: {
    productPageItem: function (newVal) {
      this.getActivePack();
      this.$http
        .get(process.env.VUE_APP_API + "categories")
        .then((res) => {
          this.models = res.data.payload.filter(
            (item) => item.parent_id === null
          );
          let newTag = this.models.find(
            (item) => item.id === newVal.parent_cat_id
          );
          newTag = newTag["title"];
          this.tag = newTag;

          this.categories = res.data.payload.filter(
            (item) => item.parent_id !== null
          );
          let category = this.categories.find(
            (item) => item.id === newVal.category_id
          );
          category = category["title"];
          this.category = category;
        })
        .catch(() => {});
    },
    currency: function (newVal) {
      console.log(newVal);
      const id = this.$route.params.id.replace(/\D/g, "");
      const type = this.$route.params.id.replace(/[^A-Za-z]+/g, " ");
      this.$emit("getProductPageContent", id, type);
    },
  },
  created() {},
  mounted() {
    this.getActivePack();
    const id = this.$route.params.id.replace(/\D/g, "");
    const type = this.$route.params.id.replace(/[^A-Za-z]+/g, " ");
    this.$emit("getProductPageContent", id, type);
  },
  methods: {
    openBuyModal(item) {
      this.$emit("openBuyModal", item, item.type);
    },

    goToProduct(item) {
      this.$emit("goToProduct", item);
    },
    getActivePack() {
      if (this.productPageItem && this.productPageItem.type == "pack") {
        this.$http
          .get(process.env.VUE_APP_API + "packs/" + this.productPageItem.id)
          .then((res) => {
            this.productList = res.data.payload;
          })
          .catch(() => {});
      } else {
        if (!this.productPageItem) {
          this.$emit(
            "getProductPageContent",
            this.$route.params.id,
            this.$route.params.type
          );
        }
      }
    },
  },
};
</script>
